const padroes = [
    { 'label': 'Alto', value: 'Alto' },
    { 'label': 'Alto +', value: 'Alto +' },
    { 'label': 'Condomínio de Casas/Sobrados', value: 'Condomínio de Casas/Sobrados' },
    { 'label': 'Condomínio de Chácaras', value: 'Condomínio de Chácaras' },
    { 'label': 'Econômico', value: 'Econômico' },
    { 'label': 'Compacto', value: 'Compacto' },
    { 'label': 'Loteamento Aberto', value: 'Loteamento Aberto' },
    { 'label': 'Loteamento Fechado', value: 'Loteamento Fechado' },
    { 'label': 'Médio', value: 'Médio' },
    { 'label': 'Médio-Alto', value: 'Médio-Alto' },
    { 'label': 'Standard', value: 'Standard' },
    { 'label': 'Super Econômico', value: 'Super Econômico' },
    { 'label': 'Luxo', value: 'Luxo' },
];

const padroesHorizontais = [
    { value: 'Condomínio de Casas/Sobrados', label: 'Condomínio de Casas/Sobrados' },
    { value: 'Condomínio de Chácaras', label: 'Condomínio de Chácaras' },
    { value: 'Loteamento Aberto', label: 'Loteamento Aberto' }, { value: 'Loteamento Fechado', label: 'Loteamento Fechado' },
];

const padroesVerticais = [
    { value: 'Compacto', label: 'Compacto' },
    { value: 'Econômico', label: 'Econômico' },
    { value: 'Standard', label: 'Standard' },
    { value: 'Médio', label: 'Médio' },
    { value: 'Médio-Alto', label: 'Médio-Alto' },
    { value: 'Alto', label: 'Alto' },
    { value: 'Luxo', label: 'Luxo' },];

export {
    padroes,
    padroesHorizontais,
    padroesVerticais
};
